/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedShippingInfoLink_viewer$ref = any;
export type PdpSharedBlurbShipping_viewer$ref = any;
export type PdpSharedBlurbShipping_viewer = {
    readonly relevantShipping?: {
        readonly quoteRequestStatus: string | null;
    } | null;
    readonly " $fragmentRefs": PdpSharedShippingInfoLink_viewer$ref;
    readonly " $refType": PdpSharedBlurbShipping_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedBlurbShipping_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "itemId",
            "type": "String!"
        },
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String"
        },
        {
            "kind": "RootArgument",
            "name": "fetchUser",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingInfoLink_viewer",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchUser",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "relevantShipping",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "userId"
                        },
                        {
                            "kind": "Variable",
                            "name": "itemId",
                            "variableName": "itemId"
                        }
                    ],
                    "concreteType": "RelevantShippingInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "quoteRequestStatus",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '380067d62fdc0017983af6674bed1e73';
export default node;
